module.exports = __webpack_public_path__ + "img/ctrl-swap-root-stub-down-+i.cb0691b9.svg";